import { IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonCardSubtitle, IonButtons, IonButton, IonLabel, IonToolbar, IonModal, IonHeader, IonIcon, IonContent, IonTitle, IonAlert } from "@ionic/react"
import { busOutline, busSharp, closeOutline, closeSharp, walkOutline, walkSharp } from "ionicons/icons"
import React, { useState } from "react"
import { Stage } from "../features/pilgrimage/stage"
import { AddLogEntry } from "../features/log/AddLogEntry"
import { ProgressMap } from "./ProgressMap"
import { useDispatch, useSelector } from "react-redux"
import { addTrip, selectMode } from "../features/log/logSlice"
import { selectPilgrimage } from "../features/pilgrimage/pilgrimageSlice"
import { selectUserName } from "../features/user/userSlice"
import { LogEntry } from "../features/log/logEntry"
import { TripType } from "../features/log/tripType"
import { createLogEntryInDatabase } from "../utils/airtable-api"

type ProgressMapCardProps = {
  stage: Stage;
  index: number;
  remainder: number;
}

export const ProgressMapCard = ({ stage, index, remainder } : ProgressMapCardProps) => {
  const dispatch = useDispatch(),
    walked = stage.distance - remainder,
    mode = useSelector(selectMode),
    user = useSelector(selectUserName),
    pilgrimage = useSelector(selectPilgrimage);

  const [showModal, setShowModal] = useState(false),
    [showBusAlert, setShowBusAlert] = useState(false);

  const takeTheBus = async () => {
    const trip = new LogEntry({
      date: (new Date()).toISOString(),
      type: TripType.Bus,
      distance: remainder,
      leg: null,
      notes: ''
    });

    if(user && pilgrimage.id) {
      try {
        const tripId = await createLogEntryInDatabase(trip, pilgrimage.id, user, pilgrimage.homeChurch);
        trip.id = tripId;
        dispatch(addTrip(trip));
      } catch(e) {
        // usually because offline, so couldn't submit to database
        trip.id = 'OFFLINE';
        dispatch(addTrip(trip));
      }
      setShowBusAlert(false);
    }
  }
  
  return (
    <React.Fragment>
      <IonCard>
          {stage.image && <img src={stage.image} alt="" />}
          <IonCardHeader>
            <IonCardTitle>{index >= 0 && `Stage ${index + 1}:`} {stage.start.name} to {stage.end.name}</IonCardTitle>
            {mode === 'miles' && <IonCardSubtitle>{walked.toFixed(1)} {walked === 1 ? 'mile': 'miles'} walked. Only {remainder.toFixed(1)} {remainder === 1 ? 'mile' : 'miles'} left to go!</IonCardSubtitle>}
            {mode === 'points' && <IonCardSubtitle>{walked.toFixed(1)} {walked === 1 ? 'point': 'points'} logged. Only {remainder.toFixed(1)} {remainder === 1 ? 'point' : 'points'} left to go!</IonCardSubtitle>}
            <IonToolbar>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowModal(true)}>
                  <IonIcon slot="start" ios={walkOutline} md={walkSharp}></IonIcon>
                  <IonLabel>Log Your {mode === 'miles' ? 'Walk' : 'Activity'}</IonLabel>
                </IonButton>
              </IonButtons>
            </IonToolbar>
            <IonToolbar>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowBusAlert(true)}>
                  <IonIcon slot="start" ios={busOutline} md={busSharp}></IonIcon>
                  <IonLabel>Take the Bus to {stage.end.name}</IonLabel>
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonCardHeader>
          <IonCardContent>
            <div style={{
              height: "500px"
            }}>
              <ProgressMap stage={stage}/>
            </div>
          </IonCardContent>
        </IonCard>
        <IonModal isOpen={showModal}>
          <IonHeader>
            <IonToolbar>
              <IonTitle slot="start">Log Your {mode === 'miles' ? 'Walk' : 'Activity'}</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowModal(false)}>
                  <IonLabel>
                    <IonIcon ios={closeOutline} md={closeSharp}></IonIcon>
                  </IonLabel>
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent class="ion-padding">
            <AddLogEntry onSubmit={() => setShowModal(false)} />
          </IonContent>
        </IonModal>
        <IonAlert isOpen={showBusAlert}
          header={`Take the Bus to ${stage.end.name}`}
          message={`Are you sure you’d like to skip ahead to ${stage.end.name}?`}
          buttons={[
            {
              text: 'Cancel',
              role: 'cancel'
            },
            {
              text: 'Go Ahead',
              handler: () => takeTheBus()
            }
          ]}
        />   
    </React.Fragment>
  )
}